<template>
  <div class="product-wrapper df fdc aifs f1 w100p">


    <div class="add-coffee-popup" v-if="showAddNewCoffeePopup" @click="hideAddCoffeePopup()">
      <div class="add-coffee-popup-inner whole-page-box-global-2 whole-page-box-global-2-unset posrel df fdc" @click="stopProp($event)">
        <h3 v-if="showAddNewCoffeePopup == 'NEW'">Add a new coffee</h3>
        <h3 v-else>Edit your coffee</h3>

        <!-- <br/> -->
        <div class="product-detail product-detail-add-new df _s5" @click="selectCoffeeType('New')" v-bind:class="{
          'not-selected-coffee-type': addNewCoffeeType !== 'New',
          'add-coffee-popup-inner-selected': addNewCoffeeType == 'New'
        }">
          <div class="check-detail f1">
            <h4>Coffee Name <span class="validation-error">{{addNewCoffeeValidationError}}</span></h4>
            <input v-model="addNewCoffeeInput" placeholder="Coffee Name" type="" name="">
            <div class="more-options df w100p aic" @click="setShowMoreNewCoffeeOptions(!showMoreNewCoffeeOptions)">
              <!-- <i v-if="showMoreNewCoffeeOptions" class="icon-chevron-up icon"></i> -->
              <img v-if="showMoreNewCoffeeOptions" src="../../static/images/icon-less-options.svg" class="more-less-options"></i>
              <img v-else src="../../static/images/icon-more-options.svg" class="more-less-options">
              <!-- <i v-else class="icon-chevron-down icon"></i> -->
              <p>{{showMoreNewCoffeeOptions ? 'Less' : 'More'}} Options</p>
            </div>
            <!--  -->
            <div class="more-options-open" v-if="showMoreNewCoffeeOptions">
              <!-- <h4>Blind Tasting Identifier</h4> -->
              <!-- <input v-model="addNewCoffeeBlindTastingIdentifier" placeholder="#1, A, etc." type="" name=""> -->
              <!-- <br/> -->
              <h4>Buy Now Link</h4>
              <input v-model="addNewCoffeeBuyNowLink" placeholder="http://" type="" name="">
              <br/>
              <!-- <h4>Product Image</h4> -->
                <h4>Thumbnail</h4>
                <div v-if="addNewCoffeeImageUrl" class="dropzone-wrapper image-dropzone-wrapper posrel df fdc aic jcc add-new-image-dropzone-wrapper">
                  <img class="image-uploaded" :src="addNewCoffeeImageUrl">
                  <a class="w100p tac image-uploaded-under" @click="removeProductImage()">Remove Image</a>
                </div>
                <div v-else class="dropzone-wrapper image-dropzone-wrapper posrel add-new-image-dropzone-wrapper">
                  
                  <vue-dropzone ref="myVueDropzone" 
                          id="dropzone-a"
                          class="image-upload"
                          @vdropzone-file-added="uploadedProductImage"
                          :options="dropzoneOptions">
                  </vue-dropzone>
                  <div class="dropzone-overlay df fdc">
                    <p>Drag Image Here</p>
                    <p>or</p>
                    <a class="button-b df aic jcc">Upload File</a>
                  </div>
                </div>
              <!-- <h4>Blind Tasting Identifier (ie, #1, A, etc)</h4> -->
              <!-- <input v-model="addNewCoffeeInput" placeholder="New Coffee" type="" name=""> -->
            </div>

          </div>
        </div>
        <div class="df _s6 aic">
          <h4 v-if="showAddNewCoffeePopup == 'NEW'" class="button-1 curp" @click="addCoffee()">Add Coffee</h4>
          <h4 class="button-1 curp" v-else @click="saveCoffee()">Save</h4>
          <p class="cancel-add tac curp" @click="hideAddCoffeePopup()">Cancel</p>
        </div>



        <div class="x-close curp" @click="hideAddCoffeePopup()"><i class="fal fa-times"></i></div>


      </div>
    </div>

    <!-- <div class="top-bar-global w100p df jcsb aic breadcrumb-wrapper">
      <div class="breadcrumb df f1">
        <h2 class="breadcrumb-other" @click="goTo('/me')">Home</h2>
        <h2 class="breadcrumb-separator">-</h2>
        <h2>Coffees</h2>
      </div>
      
    </div> -->

    <div class="whole-page-box-global-2 whole-page-box-global-2-bigger w100p mb20 title-box-2-wrap">
      <div class="title-box df w100p title-box-2">
        <h3 class="title-right">My Coffees</h3>
        <h4 class="button-1" @click="addNewCoffee()">
            </i>Add New Coffee
        </h4>
        <span class="f1"></span>
        <!-- <select v-model="selectedTemplate"> -->
        <select v-model="view" class="view-select">
          <!-- <option value="" selected disabled hidden>Select</option> -->
          <option value="thumb">Thumb View</option>
          <option value="list">List View</option>
          <!-- <option :value="i" v-for="(template, i) in templates">{{template.name}}</option> -->
        </select>
      </div>
    </div>


    <div class="sub-tabs df _s2 w100p">
      <a class="my-sessions" 
        @click="goToTab('my-coffees')"
        v-bind:class="{'current-tab': currentTab == 'my-coffees'}">
        My Coffees
      </a>
<!--       <a class="upcoming-sessions" 
        @click="goToTab('upcoming-sessions')"
        v-bind:class="{'current-tab': currentTab == 'upcoming-sessions'}">
        Upcoming
      </a> -->
<!--       <a class="recently-viewed-sessions" 
        @click="goToTab('recently-viewed-sessions')"
        v-bind:class="{'current-tab': currentTab == 'explore-coffees'}">
        Recently Viewed
      </a> -->
    </div>

<!-- 
    <div class="top-bar-global w100p _position1 df jcsb aic">
    </div>
 -->
<!--     <p v-if="Object.keys($store.getters['AUTH.myCoffees'] || {}).length == 0">
      Click <span class="here" @click="addNewCoffee()">here</span> to add your first coffee.
    </p> -->

    <div v-if="Object.keys($store.getters['AUTH.myCoffees'] || {}).length == 0" class="whole-page-box-global-2 whole-page-box-global-2-line-item w100p df w100p jcsb aic _x">
      <p>Add a coffee to see it here</p>
    </div>




    <div class="w100p _s3" v-if="view == 'thumb'">
      <div class="line-list line-list-2 w100p df fdr fww">
        <div class="whole-page-box-global coffee-card df fdc jcsb posrel"
              v-for="(product, i) in $store.getters['AUTH.myCoffees']"
              v-if="!product.deleted">
              <div class="hover-overlay" @click="showAddNewCoffee(i)">
                <i class="icon fal fa-edit curp"></i>
              </div>
              <div class="step-breakdown f1 w100p df jcc aic">
                <img :class="{
                  'default-coffee-image': !product.imageUrl
                }" :src="product.imageUrl || '../../static/images/new-pic-default-coffee.svg'" class="coffee-image">
                <!-- <div class="one-step" v-for="(step, s) in product.steps">
                  <h5>{{step.name}} ({{s + 1}} of {{product.steps.length}})</h5>
                  <div class="one-step-metrics">
                    <div class="one-step-metric" v-for="(metric, m) in step.metrics">
                      {{metric.name}}
                    </div>
                  </div>
                </div> -->

              </div>
              <div class="df fdc w100p jcsb aifs">
                <p class="coffee-card-name">{{product.name}} <!-- <span class="nobold">(points)</span> --></p>
                <p class="coffee-card-date">{{formatDate(product.created)}} <!-- <span class="nobold">(points)</span> --></p>
<!--                 <i class="icon fal fa-edit curp"
                  @click="showAddNewCoffee(i)"></i> -->
              </div>
        </div>
      </div>     
    </div>
    <div class="w100p" v-if="view == 'list'">
 <!--      <div class="title-box df">
        <h3>My Coffees</h3>
        <h4 class="tac curp start-new-cupping" @click="addNewCoffee()">
            <i class="icon far fa-plus-circle"></i>New
        </h4>
      </div> -->
      
        <div class="line-list w100p df fdc">
          <div class="whole-page-box-global-2-line-item line-item-header w100p df w100p jcsb aic">
              <img src="" class="list-coffee-image hx o0">
              <p class="f2">Name</p>
              <p class=""></p>
              <p>Created</p>
              <p></p>
          </div>
          <div class="whole-page-box-global-2 whole-page-box-global-2-line-item w100p df w100p jcsb aic _s1"
                @click="showAddNewCoffee(i)"
                v-for="(product, i) in $store.getters['AUTH.myCoffees']"
                v-if="!product.deleted">
                <img :class="{
                  'default-coffee-image': !product.imageUrl
                }" :src="product.imageUrl || '../../static/images/default-coffee-square.svg'" class="list-coffee-image">
                <p class="f2 product-name">{{product.name}}</p>
                <p class="">
                </p>
                <p>{{formatDate(product.created)}}</p>
                <p><i class="icon fal fa-edit"></i></p>
          </div>
        </div>     
    </div>


<!-- 
    <div class="whole-page-box-global hover-fx w100p df fdc"
          @click="showAddNewCoffee(i)"
          v-for="(product, i) in $store.getters['AUTH.myCoffees']"
          v-if="!product.deleted">
      <p class="curp one-product df">
        {{product.name}}
      </p>
    </div> -->
 

  </div>
</template>

<script>

import router from '@/router'
import LandingProduct from '@/components/LandingProduct'
import templates from '@/util/tasting_templates'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { firebase } from '@/util/firebase'
// import {firebaseInstance} from '@/util/firebase'

export default {
  name: 'Coffees',
  data () {
    return {
      currentTab: 'my-coffees',
      view: 'thumb',
      loading: false,
      coffees: {},
      showMoreNewCoffeeOptions: false, 
      addNewCoffeeInput: '', 
      addNewCoffeeImageUrl: '', 
      addNewCoffeeBuyNowLink: '', 
      addNewCoffeeValidationError: '', 
      showAddNewCoffeePopup: false,
      addNewCoffeeType: 'New',
      // templates: templates
      productImageUrl: '',

      dropzoneOptions: {
          autoProcessQueue: false,
          url: 'https://',
          thumbnailWidth: 150,
          maxFilesize: 1,
          // headers: { "My-Awesome-Header": "header value" },
          // dictDefaultMessage: 'Check',
          // previewTemplate: document.querySelector('#template-container').innerHTML
          dictDefaultMessage: ``
      },
    }
  },
  props: ['mode'],
  components: {
    LandingProduct,
    vueDropzone: vue2Dropzone
  },
  methods: {
    goToTab (tab) {
        this.currentTab = tab
      // if (tab == 'my-sessions') {
        // this.loading = true
      // } else if (tab == 'recently-viewed-sessions') {
        // this.loading = true
        // this.currentTab = tab
      // } 
    },
    addNewCoffee () {      
      this.showAddNewCoffeePopup = 'NEW'
      document.body.className = 'popup-shown';
    },
    removeProductImage () {
      this.addNewCoffeeImageUrl = ''
    },
    saveCoffee () {
      let run = async () => {
        let coffeeObject = {
          name: this.addNewCoffeeInput,
          imageUrl: this.addNewCoffeeImageUrl,
          buyNowLink: this.addNewCoffeeBuyNowLink,
          coffeeId: this.showAddNewCoffeePopup
        }
        // validate
        console.log('coffeeObject', coffeeObject)
        if (coffeeObject.name) {
          var savedCoffee = firebase.functions().httpsCallable('saveCoffee')
          let p = await savedCoffee(coffeeObject)
          this.clearAddCoffeeForm()
          this.showAddNewCoffeePopup = false
          // document.body.className = document.body.className.replace("no-javascript","");
          document.body.className = '';
        } else {
          this.addNewCoffeeValidationError = '*Please give the coffee a name'
        } 
      }
      run()


      console.log('abc', this.coffees)

    },
    addCoffee () {
      let run = async () => {
        let coffeeObject = {
          name: this.addNewCoffeeInput,
          imageUrl: this.addNewCoffeeImageUrl,
          buyNowLink: this.addNewCoffeeBuyNowLink,
        }
        // validate
        console.log('coffeeObject', coffeeObject)
        if (coffeeObject.name) {
          var addedCoffee = firebase.functions().httpsCallable('addNewCoffee')
          let p = await addedCoffee(coffeeObject)
          this.clearAddCoffeeForm()
          this.showAddNewCoffeePopup = false

          document.body.className = '';
        } else {
          this.addNewCoffeeValidationError = '*Please give the coffee a name'
        } 
      }
      run()


      console.log('abc', this.coffees)

    },
    // addNewCoffee () {
    //   let coffees = this.coffees
    //   let coffeeObject = {}

    //   // check new of existing selected
      
    //   let run = async () => {
    //     if (this.addNewCoffeeType == 'New') {
    //       coffeeObject = {
    //         name: this.addNewCoffeeInput,
    //         imageUrl: this.addNewCoffeeImageUrl,
    //         buyNowLink: this.addNewCoffeeBuyNowLink,
    //         // bag: 'blue' // ?
    //       }
    //       // validate
    //       console.log('coffeeObject', coffeeObject)
    //       if (coffeeObject.name) {
    //         // create coffee

    //         var addedCoffee = firebase.functions().httpsCallable('addNewCoffee')
    //         let p = await addedCoffee(coffeeObject)

    //         coffees.push(coffeeObject)
    //         this.coffees = coffees

    //         this.clearAddCoffeeForm()

    //         this.showAddNewCoffeePopup = false
    //       } else {
    //         this.addNewCoffeeValidationError = '*Please give the coffee a name'
    //         console.log('addNewCoffeeValidationError', this.addNewCoffeeValidationError)
    //       }
    //     } else if (this.addNewCoffeeType == 'Existing') {
    //       console.log('existing coffee', this.selectedCoffee)

    //       if (this.selectedCoffee) {
    //         let coffeeObject = this.$store.getters['AUTH.myCoffees'][this.selectedCoffee]
    //         coffeeObject.blindTastingId = this.addExistingCoffeeBlindTastingIdentifier
    //         // create coffee
    //         coffees.push(coffeeObject)
    //         this.coffees = coffees

    //         this.clearAddCoffeeForm()

    //         this.showAddNewCoffeePopup = false
    //         // flash new coffee ?
    //       } else {
    //         this.addExistingCoffeeValidationError = '*Please select a coffee'
    //         console.log('addExistingCoffeeValidationError', this.addExistingCoffeeValidationError)
    //       }
    //     }

    //   }
    //   run()


    //   console.log('abc', this.coffees)

    // },
    uploadedProductImage (file) {
      let item = {
        productId: this.productId,
        file
      }
      this.$store.dispatch('AUTH.uploadProductImage', item).then((res) => {
        console.log('res', res.url)
        this.addNewCoffeeImageUrl = res.url
      })
    },
    clearAddCoffeeForm () {
      this.showMoreNewCoffeeOptions = false
      this.addNewCoffeeType = 'New'
      this.addNewCoffeeInput = ''
      this.addNewCoffeeImageUrl = ''
      this.addNewCoffeeBuyNowLink = ''
      this.addExistingCoffeeValidationError = ''
      this.productImageUrl = ''
    },
    selectCoffeeType (type) {
      console.log('type', type)
      if (type == 'Existing') {
        this.showMoreNewCoffeeOptions = false
      } else if (type == 'New') {
        this.showMoreExistingCoffeeOptions = false
      }
      this.addNewCoffeeType = type
    },
    setShowMoreNewCoffeeOptions (v) {
      this.showMoreNewCoffeeOptions = v
    },
    stopProp (e) {
      e.stopPropagation()
    },
    showAddNewCoffee (i) {
      this.showAddNewCoffeePopup = i
      document.body.className = 'popup-shown';
      this.populateExistingCoffee()
    },
    hideAddCoffeePopup () {
      // if (this.showAddNewCoffeePopup) {
      this.showAddNewCoffeePopup = false
      document.body.className = '';
      this.clearAddCoffeeForm()
      // }
    },
    newProduct (product) {
      this.goTo('/add/' + product)
    },
    goTo (route) {
      router.push(route)
    },
    goToProduct (product) {
      // let path = '/templates/' + product
      // router.push(path)
    },
    productTypeDisplay (type) {
      // let type = this.productType
      if (type == 'digital-download') {
        return 'Digital Download'
      } else if (type == 'digital-service') {
        return 'Service'
      } else if (type == 'calendar-event') {
        return 'Calendar Invite'
      }
      return ''
    },
    balance () {
      let balance = 0
      let income = this.income
      for (let item in income) {
        let earned = income[item].order[0].earned ? parseFloat(income[item].order[0].earned) : parseFloat(income[item].order[0].price)
        balance = balance + earned
      } 
      return parseFloat(balance/100).toFixed(2)
    },
    formatCurrency (c) {
      return (c/100).toFixed(2)
    },
    formatDate (date) {

      Number.prototype.padLeft = function(base,chr){
         var  len = (String(base || 10).length - String(this).length)+1;
         return len > 0? new Array(len).join(chr || '0')+this : this;
      }

      var d = new Date(date),
        dformat = [ (d.getMonth()+1).padLeft(),
                    d.getDate().padLeft(),
                    d.getFullYear()].join('/')
                  //   +
                  //   ' ' +
                  // [ d.getHours().padLeft(),
                  //   d.getMinutes().padLeft()].join(':');

               return dformat
    },
    populateExistingCoffee () {
      if (this.$store.getters['AUTH.uid']) {
        let coffees = this.$store.getters['AUTH.myCoffees']
        let coffee = coffees[this.showAddNewCoffeePopup]
        console.log('coffee', coffee)

        if (coffee) {
          this.addNewCoffeeBuyNowLink = coffee.buyNowLink
          this.addNewCoffeeImageUrl = coffee.imageUrl
          this.addNewCoffeeInput = coffee.name
        }
      }


      // showAddNewCoffeePopup

      // this.addNewCoffeeType = 'New'
      // this.addNewCoffeeInput = ''
      // this.addNewCoffeeImageUrl = ''
      // this.addNewCoffeeBuyNowLink = ''
      // this.addExistingCoffeeValidationError = ''
      // this.productImageUrl = ''
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    this.populateExistingCoffee()
    console.log('* Landing page created')
  }
}
</script>

<style scoped lang="scss">
  @import "../styles/settings.scss";

  ._position1 {
    margin-top: 8px;
  }


  /* Page sub tabs */
  .sub-tabs {
    padding-left: 0;
    a {
      color: #5C5C5C;
      font-family: Inter;
      font-size: 14px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 16px;
      margin-right: 47px;
      border-bottom: 5px solid transparent;
      padding-bottom: 8px;
      &:last-child {
        margin-right: 0;
      }
      &:hover {
        border-bottom: 5px solid #BEBEBE;
      }
    }
  }
  .current-tab {
    border-bottom: 5px solid #BEBEBE !important;
  }
  ._s1 {
    margin-bottom: 17px;
    padding-left: 15px;
    /*padding-right: 15px;*/
  }
  ._s2 {
    margin-top: 22px;
    margin-bottom: 6px;
  }
  ._s3 {
    margin-top: 22px; 
    margin-top: 30px; 
  }
  ._s4 {
    margin-right: 30px;
  }
  ._s5 {
    padding-left: 0;
    padding-right: 0;
    background-color: transparent !important;
  }
  ._s6 {
    margin-top: 10px;
  }

  h1 {
    text-transform: capitalize;
  }

  h2 {
    /*font-size: 24px;*/
    /*font-weight: 500;*/
    /*font-family: 'Rubik', 'sans-serif';*/
    /*letter-spacing: .04em !important;*/
    color: #2b2b2b;
  }

  h3 {
    // margin-bottom: 18px;
    text-align: left;
    color: #5469d4;
  }

  hr {
    margin-bottom: 45px;
  }

  .product-wrapper {
    /*background-color: #292929;*/
    /*max-width: calc(100% - 280px);*/
    padding: 19px;
    padding-top: 0px;
  }
  .product-splash, .product-choose-your-feel {
    width: 100%;
    height: 566px;
    margin-bottom: 120px;
  }
  .product-products {
    flex-wrap: wrap;
  }
  .product-product-image {
    width: 515px;
    min-width: 515px;
    height: 566px;
  }
  .top-bar-global {
    /*height: 68px;*/
  }
  .whole-page-box-global {
  }
  $image-upload-size: 200px;
  .image-upload {
    width: $image-upload-size;
    height: $image-upload-size;
    border-radius: 6px;
    /*padding: 12px;*/

    /*border: 1px dashed rgba(50, 50, 93, 0.1);*/
    border: 2px dashed #BFBFBF;
    font-size: 16px;
    background: white;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:hover {
      & + .dropzone-overlay {
        background-color: #fdfdfd;
        /*border: 1px dashed rgba(50, 50, 93, 0.12);*/
        border: 2px dashed #BFBFBF;
        
        a {
          background-color: #5469d4;
          color: $color-white;
        }
      }
    }

    & > * {
      margin: 0 !important;
    }
  }
  .image-uploaded {
    width: $image-upload-size;
    height: $image-upload-size;
    border-radius: 6px;
    border: 1px solid rgba(50, 50, 93, 0.1);
    object-fit: cover;
  }
  .image-uploaded-under {
    margin-top: 6px;
    font-size: 12px;
  }
  .file-upload {
    width: 100%;
    /*max-width: 500px;*/
    height: 150px;
    border-radius: 6px;
    /*padding: 12px;*/
    border: 1px dashed rgba(50, 50, 93, 0.1);
    font-size: 16px;
    background: white;
    /*margin-right: 20px;*/
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:hover {
      & + .dropzone-overlay {
        background-color: #fdfdfd;
        border: 1px dashed rgba(50, 50, 93, 0.12);
        
        a {
          background-color: #5469d4;
          color: $color-white;
        }
      }
    }
  }
  .product-delivery-file {
    & > div {
      border: 1px solid rgba(50, 50, 93, 0.1);
      border-radius: 6px;
      width: 100%;
      height: 150px;
    }
  }
  .dropzone-overlay {
    border-radius: 6px;
    position: absolute;
    left: 0;
    bottom: 0;
    height: 100%;
    max-height: 200px;
    width: 100%;
    /*background-color: #aaa;*/
    pointer-events: none;
    display: flex;
    justify-content: center;
    align-items: center;
/*    background-color: #fbfbfb;
    border: 1px dashed rgba(50, 50, 93, 0.12);*/

    p, {
      font-size: 14px;
      margin-bottom: 6px;
    }

  }
  .product-basics {
    /*height: 200px;*/
    min-height: 200px;
  }
  textarea {
    border-radius: 6px;
    padding: 12px;
    border: 1px solid rgba(50, 50, 93, 0.1);
    height: 44px;
    font-size: 16px;
    width: 100% !important;
    background: white;
    margin-bottom: 6px;
  }
  .digital-download-details {
    height: 100%;
  }
  .product-detail {
    margin-bottom: 20px;
    /*max-width: 500px;*/
  }
  .product-detail-outer {
    /*max-width: 500px;*/

    & > .product-detail {
      flex: 1;
      &:first-child {
        flex: 2;
        /*margin-right: 20px;*/
      }
    }
  }
  .product-basics {
    max-width: 500px;
    & > .product-detail {
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
  $placeholderColor: #898989;
  h3 {
    color: #5C5C5C;
    font-family: Inter;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 20px;
    .icon {
      margin-right: 6px;
    }
  }
  h4 {
    /*font-family: 'Rubik', 'sans-serif';*/
    /*font-size: 14px;*/
    /*letter-spacing: 0.2px;*/
    /*font-weight: 500;*/
    /*margin-bottom: 0.5rem;*/
    /*color: rgb(43, 43, 43);*/
  }
  input, textarea, select {
    width: 100%;
    max-width: 540px;
    border-color: #BFBFBF !important;
    background-color: #fff;
    font-size: 14px;
    padding: 12px 10px;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: 'Rubik', 'sans-serif';
    color: rgb(43, 43, 43);
    border-radius: 6px; 


    ::-webkit-input-placeholder { /* Edge */
      color: $placeholderColor;
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: $placeholderColor;
    }

    ::placeholder {
      color: $placeholderColor;
    }
  }
  .sub-line {
    margin-bottom: 8px;
    font-size: 12px;
  }
  .check-fulfillment {
    margin-right: 20px;

    input {
      width: 20px;
    }
  }
  .check-fulfillment-box {
    display: flex;
    flex-direction: column;
    height: 20px;
    margin: 0;
  }
  .mw2 {
    /*max-width: 500px;*/
  }
  .mw3 {
    /*max-width: 500px;*/
  }
  .just-save {
    background-color: transparent;
    box-shadow: none;
    color: #2b2b2b;
  }
  .button-b {
    border: 1px solid #5469d4;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: #5469d4;
    padding: 2px 6px;
    height: 30px;

    &:hover {
      border: 1px solid transparent;
      background-color: #5469d4;
      color: $color-white;
    }
  }
  .image-dropzone-wrapper {
    /*margin-left: 20px;*/
  }
  .file-icon {
    opacity: 0.5;
    height: 35px;
    margin-bottom: 10px;
  }
  .file-text {
    font-size: 14px;
    margin-bottom: 10px;
  }
  .file-remove-text {
    font-size: 10px;
    text-decoration: underline;
  }
  .r0 {
    margin-right: 10px;
  }
  .r1 {
    margin-left: 10px;
  }
  .one-day {
    margin-top: 4px;
    margin-bottom: 4px;
  }
  .max-detail {
    /*max-width: 350px;*/
    select {
      max-width: 300px;
    }
  }
  .reference {
    margin-top: 4px;
    font-size: 12px;
    margin-bottom: 12px;
  }
  .previews {
    div {
      a {
        font-size: 14px;
        color: #444;
      }
    }
  }

  @media (max-width: 980px) {
    .digital-download-details {
      flex-direction: column;
      .dropzone-wrapper {
        margin-left: 0;
        margin-bottom: 20px;
      }
    }
    .product-basics {
      width: 100%;
    }
  }

  .delete-product {
    font-size: 12px;
    margin-top: 30px;
    margin-left: 40px;
    display: flex;
    justify-content: flex-end;
    padding-right: 40px;
    cursor: pointer;
  }

  .minh {
    height: 100%;
  }

  .o05 {
    opacity: 0.5;
    pointer-events: none;
  }
  .o00 {
    opacity: 0;
    pointer-events: none;
  }
  @media (max-width: 980px) {
    .o00 {
      display: none;
    }
  }
  .mty {
    margin-top: 20px;
  }

  .selected-coffees {
    border: 1px solid #ddd;
    border-radius: 10px;
    background-color: #eee;
    padding: 10px;
    margin-bottom: 10px;

    .one-selected-coffee {
      height: 100px;
      width: 100px;
      border-radius: 10px;
      padding: 10px;
      border: 1px solid #dfdfdf;
      background-color: #fefefe;
      position: relative;
      margin-left: 5px;
      margin-right: 5px;

      p {
        font-size: 14px;
        font-weight: 500;
        color: #333;

        &:last-child {
          font-size: 12px;
          color: #555;
        }
      }

      .remove-selected-coffee {
        position: absolute;
        top: 10px;
        right: 10px;
        line-height: 12px;
        font-size: 15px;
        cursor: pointer;
      }
    }
    .add-new-coffee {
      border: 2px dashed #bbb;
      background-color: #eee;
      cursor: pointer;

      &:hover {
        background-color: #fafafa;
      }
      .span {
      }
    }
    .plus {
      font-size: 28px !important;
      line-height: 28px !important;
      color: #999 !important;
    }

    .name {
      font-size: 12px !important;
      color: #999 !important;
    }
    .none-selected {
      font-size: 12px;
    }
  }

  .breadcrumb-wrapper {
    h3 {
      margin-bottom: 0;
      font-weight: 500;
      i {
        margin-right: 6px;
      }
    }
  }

  .more-options {

  }

  .more-options-open {
    margin-top: 22px;
    padding: 0;
  }

  .hover-fx {
    margin-bottom: 20px;
  }
  .add-coffee-popup-inner {
    margin-left: 30px;
    margin-right: 30px;
    & > * {
      width: 100%;
    }
  }
  .add-coffee-popup-inner {
    /*padding-right: 10px !important;*/
    max-height: 100vh;
    overflow-y: auto;
  }

  @media (max-width: 440px) {
    .add-coffee-popup-inner {
      margin-left: 15px;
      margin-right: 15px;
    }
  }

  .here {
    text-decoration: underline;
    cursor: pointer;
    font-weight: 700;
    color: #5469d4;
  }
  h4 {
    color: $color-primary;
    font-weight: 500;
    font-family: Inter;
    i {
      padding-right: 10px;
    }
  }
  .start-new-cupping {
    /*padding: 7px 18px;*/
    /*position: absolute;*/
    /*top: 50%;*/
    /*transform: translateY(-50%);*/
    /*right: 0;*/
    /*border: 1px solid $color-primary;*/
    margin-left: 20px;
    border-radius: 5px;
    position: relative;

    &:hover, &:active {
      p, i {
        z-index: 2;
      }
      &::before {
        position: absolute;
        left: -6px;
        top: -6px;
        content: ' ';
        width: calc(100% + 12px);
        height: 30px;
        border: 1px solid $color-primary;
        border-radius: 5px;
        z-index: 0;
      }
    }
  }
  .fa-edit {
    width: 25px;
    font-size: 25px;
    display: flex;
    justify-content: flex-end;
    margin-left: 10px;
  }
  .nobold {
    font-weight: 400;
  }
  .whole-page-box-global {
    padding-right: 0px;
  }
  @media (max-width: 530px) {
    .whole-page-box-global {
      padding-right: 10px;
    }
  }
  @media (max-width: 420px) {
    .product-wrapper {
      /*padding-left: 0;*/
      /*padding-right: 0;*/
    }
    .whole-page-box-global {
      border-radius: 0;
    }
  }
  @media (max-width: 1020px) {
    .add-coffee-popup {
      width: 100%;
    }
    .add-coffee-popup-inner {
      height: 100vh;
      width: 100% !important;
      max-width: unset !important;
      border-radius: 0;
      margin: 0;
    }
  }

  .x-close {
    font-size: 22px;
  }
  .coffee-image {
    height: 110px;
    width: 100%;
    object-fit: contain;
  }
  .default-coffee-image {
    /*opacity: 0.75;*/
  }
  .save-session-error, .validation-error {
    color: #ff0c0c !important;
  }
  button {
    border-radius: 5px;
  }
  .title-right {
    margin-right: 27px;
  }
  .mb20 {
    /*margin-bottom: 20px;*/
  }
  select {
    border-radius: 0;
    border: 1px solid black;
    background-color: transparent;
    -webkit-appearance: none;
    -moz-appearance: none;
    position: relative;
    /*padding-right: 20px;*/
    background-image: url('../../static/images/new-icon-chevron-down.svg');
    background-repeat: no-repeat;
    background-position: 95% 50%;
    &::after {
      content: ' ';
      width: 14px;
      height: 8px;
      background-position: center;
      background-size: contain;
      /*position: absolute;*/
      right: 10px;
      top: 2px;
    }
  }
  .view-select {
    max-width: 176px;
  }
  .line-list-2 {
    display: grid;
    row-gap: 23px;
    column-gap: 25px;
    grid-template-columns: repeat(auto-fill,minmax(294px, 294px));
    /*margin: -25px;*/
    /*margin-right: 0;*/
  }
  .coffee-card {
    flex: 1;
    max-width: 294px;
    height: 233px;
    padding: 33px 37px;
    cursor: pointer;
    /*max-width: 400px;*/
    /*margin-right: 25px;*/
    /*margin-bottom: 23px;*/
    .hover-overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      border-radius: 5px;
      background-color: rgba(0,0,0,0.55);
      /*display: flex;*/
      justify-content: center;
      align-items: center;
      color: white;
      display: none;
      i {
        width: unset;
        margin-left: 0;
        font-size: 49px;
      }
    }
    &:hover {
      .hover-overlay {
        display: flex;
      }
    }
  }
  .coffee-card-name {
    color: #000000;
    font-family: Inter;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 17px;
    margin-top: 16px;
  }
  .coffee-card-date {
    color: #49494C;
    font-family: Inter;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 17px;
    text-align: right;
    margin-top: 4px;
  }
  .list-coffee-image {
    width: 54px;
    height: 54px;
    margin-right: 30px;
  }
  .hx {
    height: 2px;
  }
  .o0 {
    opacity: 0;
  }

  .line-item-header {
    height: 44px;
    padding-top: 13px;
    padding-left: 15px;
    padding-right: 57px;
    margin-bottom: 2px;
    /*width: calc(100% - 114px);*/

    &:hover {
      box-shadow: none !important;
    }
  }




  .whole-page-box-global-2-line-item {
    &:hover {
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2);
    }

    p {
      color: #49494C;
      font-family: Inter;
      font-size: 16px;
      letter-spacing: 0;
      line-height: 17px;
      // text-align: right;
      &:first-child {
        flex: 1;
        width: 40%;
        color: #000000;
        font-family: Inter;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 17px;
      }
      &:nth-last-child(4) {
        /*width: 40%;*/
        /*width: 62px;*/
        width: 150px;
        display: flex;
        & > * {
          flex: 1;
          font-size: 20px;
        }
      }
      &:nth-last-child(3) {
        /*width: 40%;*/
        width: 60px;
        margin-left: 8px;
      }
      &:nth-last-child(2) {
        /*width: 40%;*/
        width: 140px;
        margin-left: 18px;
        margin-right: 4px;
      }
      &:last-child {
        width: 25px;
        font-size: 18px;
      }
    }
  }
  .whole-page-box-global-2-line-item {
    cursor: pointer;
    p {
      &:nth-last-child(3) {
        // font-size: 12px;
      }
      &:nth-last-child(2) {
        // font-size: 13px;
      }
    }
  }
  @media (max-width: 640px) {
    .whole-page-box-global-2-line-item {
      height: 60px;
      flex-wrap: wrap;
      justify-content: flex-end;
      padding-top: 8px;
      padding-bottom: 6px;
      p {
        &:first-child {
          width: 100%;
          /*height: 30px;*/
          min-width: 100%;
          display: flex;
          align-items: center;
        }
      }
    }
  }
  @media (max-width: 380px) {
    .whole-page-box-global-2-line-item {
      justify-content: flex-start;
      height: unset;
      padding-top: 6px;
      padding-bottom: 6px;
      padding-right: 10px;
      p {
        width: 100%;
        margin-left: 0 !important;
        &:last-child {
          flex: 1;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }

  .product-name {
    color: #000000 !important;
    font-family: Inter;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 17px;
  }

  .more-less-options {
    margin-right: 6px;
  }

  .cancel-add {
    margin-left: 57px;
  }

  ._x {
    margin-top: 10px;
  }

  @media (max-width: 620px) {
    .line-list-2 {
      display: flex;
      flex-direction: column;
    }
    .title-box-2 {
      flex-direction: column;
      padding-top: 30px;
      padding-bottom: 30px;

      &-wrap {
        height: unset;
      }

      h3 {
        margin-right: 0;
        margin-bottom: 15px;
      }
      h4 {
        margin-bottom: 15px;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/Coffees.vue